import React, { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// Load layout components
import PageSpinner from '../components/layout/PageSpinner';
import LoadingplacesComponent from '../components/loadingplaces/LoadingplacesComponent';

import { GlobalContext } from '../store/Provider';

const Loadingplaces = () => {
  const { t } = useTranslation();

  const { loadingplacesState } = useContext(GlobalContext);

  return (
    <Fragment>
      <h1>{t('loadingplaces.name')}</h1>
      {loadingplacesState.loadingplaces.fetching ? (
        <PageSpinner msg={t('general.stillFetchingData')} />
      ) : (
        <LoadingplacesComponent />
      )}
    </Fragment>
  );
};

export default Loadingplaces;
